// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1921":"0e88cd1e73c69969","2888":"0f8a8b774a6bbfc6","7482":"0e88cd1e73c69969"}[chunkId] + ".css";
};